import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, FileTextIcon, HandCoinsIcon, KeyRoundIcon } from 'lucide-react';
import { learnItems } from '../data/seminar';
const icons = {
  'check-circle': CheckCircle2Icon,
  'file-text': FileTextIcon,
  'hand-coins': HandCoinsIcon,
  'key-round': KeyRoundIcon
};
export function LearnSection() {
  return <section id="aprender" className="w-full bg-white py-20 sm:py-28" data-id="element-79" data-mp="2i6u0iw2yiadg">
      <div className="mx-auto max-w-6xl px-6" data-id="element-80" data-mp="2n3kbx63tghsj">
        <div className="mx-auto max-w-2xl text-center" data-id="element-81" data-mp="2s2x0bvac5wx8">
          <span className="section-label" data-id="element-82" data-mp="2s1c666rxofzw">El contenido</span>
          <h2 className="mt-5 font-serif text-4xl font-light leading-tight text-navy sm:text-5xl" data-id="element-83" data-mp="2x206xk5ysb7b">
            ¿Qué vas a aprender en este seminario?
          </h2>
          <div className="mx-auto mt-7 h-px w-16 bg-gold" aria-hidden="true" data-id="element-84" data-mp="12o8obv5nqgzq" />
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:gap-8" data-id="element-85" data-mp="12qlg1017w5pz">
          {learnItems.map((item, index) => {
          const Icon = icons[item.icon];
          return <motion.li key={item.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.45,
            delay: index * 0.06
          }} className="rounded-2xl bg-cream p-8 shadow-soft sm:p-10" data-id="element-86" data-mp="3qyg0zqcphye4" data-mpi={index}>
                <Icon className="h-8 w-8 text-gold" strokeWidth={1.25} aria-hidden="true" data-id="element-87" data-mp="dpa8q1ysoalq" />
                <h3 className="mt-6 font-serif text-2xl font-medium text-navy sm:text-3xl" data-id="element-88" data-mp="8sjuzlagpr3h">
                  {item.title}
                </h3>
                <p className="mt-3 font-sans text-sm font-light leading-relaxed text-ink sm:text-base" data-id="element-89" data-mp="3u8j750lx6im">
                  {item.description}
                </p>
              </motion.li>;
        })}
        </ul>
      </div>
    </section>;
}